var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.479,
    height: 17.178
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.099 17.177h3.736V5.195H.099ZM1.943 3.723a1.865 1.865 0 1 1 .044-3.724 1.866 1.866 0 1 1-.048 3.723Zm11.8 13.454h3.736v-7.085c0-3.528-1.843-5.169-4.3-5.169a4.33 4.33 0 0 0-3.713 1.934h-.079l-.171-1.664H5.973c.05 1.076.1 2.327.1 3.823v8.159h3.738v-6.908a2.6 2.6 0 0 1 .125-.931 2.05 2.05 0 0 1 1.914-1.395c1.351 0 1.893 1.049 1.893 2.6Z"
  })));
};
export default SvgLinkedin;